export class Clinic {
  Id: number;
  CreateTime: Date;
  Creater: string;
  EditTime: Date;
  Editor: string;
  IsEnabled: boolean;

  CompanyId: string;
  Code: string;
  Name: string;
  Address: string;
  Street: string;
  Area: string;
  City: string;
  Country: string;
  State: string;
  ZipCode: string;
  Phone: string;
  Email: string;
  Fax: string;
  Sort: number;
  NHICode: string;
  NHILevel: string;
  NHIType: number;
  Type: number;
  OwnerId: string;
  OwnerName: string;
  MedDeptCode: string;
  OpenDate: Date;
  StartDate: Date;
  EndDate: Date;
  ExpireDate: Date;
  IsStandard: boolean;
  MedDivSdate: Date;
  HasPharmacist: boolean;
  // get properties
  IsEffective: boolean = false;
  TypeIsClinic: boolean = false;
  TypeIsPharmacy: boolean = false;
  TypeIsDental:boolean = false;
  TypeIsMember: boolean = false;
  TypeIsHomeCare: boolean = false;
  TypeIsRecoveryHome: boolean = false;
  TypeIsChinese: boolean = false;
  NotUseDispTP: boolean = false;
  AllowMakeUp: boolean = false;
  IsLackResource: boolean = false;
  IsMountain: boolean = false;
  BusinessLicense: string;
  ControlledDrugLicenseNo: string;
  PolarisHostUrl?: string;
  CustomerServiceExt: string;
  EName: string;
  OwnerEName: string;
  EAddress: string;
  IsKM :boolean;
  StockClass?: number;
  ServicePhone:string;
}
